/* eslint @typescript-eslint/explicit-function-return-type: off */

export const indexPath = (projectId) => `/projects/${projectId}/data_sources`;
export const createPath = indexPath;
export const detailsPath = (projectId, dataSourceId) =>
  `/projects/${projectId}/data_sources/${dataSourceId}`;
export const updatePath = detailsPath;
